export class LegendDefs {
    static MAX_CASES = 60;
    static LEGEND_GRADIENT = ['#ffffcc','#ffeda0','#fed976','#feb24c','#fd8d3c','#fc4e2a','#e31a1c','#bd0026','#800026'];
}